import React from 'react'
import s from './AddressHPMainContent.less'
import Footer from '../footer/Footer'
import FakeHotelCalendar from './FakeHotelCalendar'
import GeoentitiesAtAddressPicker from './GeoentitiesAtAddressPicker'
import T, { useT } from '../i18n/T'
import CitiesToDiscover from '../home/CitiesToDiscover'

export default function AddressHPMainContent() {
  return (
    <>
      <div className={s.addressMainContent}>
        <div className={s.addressContent}>
          <div className={s.mainHeader}>
            <AddressHPTitle />
          </div>
          <div className={s.description}>
            <AddressHPDescription />
          </div>
        </div>
        <GeoentitiesAtAddressPicker />
        <FakeHotelCalendar />
        <CitiesToDiscover />
      </div>
      <Footer />
    </>
  )
}

const AddressHPTitle = () => (
  <h1 className={s.title}>
    <T id="addresshp.title" />
  </h1>
)

const AddressHPDescription = () => {
  return useT('addresshp.description')
}
